import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { handleLogout } from "../../utils/storage";
import * as Storage from "../../utils/storage";
import httpClient from "../../utils/HttpClient";
import { NEW_TOKEN_URL } from "../../constants/Url";
import { loginSuccessAction } from "../../modules/auth/actions";
import { storageKeys } from "../../constants/storage";
import { API_ENDPOINT, API_TOKEN } from "../../config/api";
import axios from "axios";

const CheckLogin = () => {
    const user = useSelector((state) => state.authReducer);
    const dispatch = useDispatch();
    let token = user && user?.token ? user?.token : null

    const saveAuth = (newToken, member, refreshToken) => {
        dispatch(loginSuccessAction({ token: newToken, user: member, photo: member?.picUrl }));
        if (newToken) localStorage.setItem(storageKeys.TOKEN, btoa(newToken));
        // if (refreshToken) localStorage.setItem(storageKeys.TOKEN_RE, btoa(refreshToken));
        if (member) localStorage.setItem(storageKeys.USER, JSON.stringify(member));
    };

    const getNewToken = async () => {
         const refreshToken = Storage.getString(storageKeys.TOKEN_RE);
        const response = await fetch(
            `${API_ENDPOINT}${NEW_TOKEN_URL}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "x-api-token": API_TOKEN,
                    Authorization: `Bearer ${refreshToken}`
                },
                credentials: "include"
            }
        );

        const res = await response.json();

        if (res?.status === 200) {
            saveAuth(res?.accessToken, user?.user, res?.refreshToken);
        } else {
            handleLogout();
            // message.error(t(res?.error?.message || res?.message || "Failed to login"));
        }
    }

    useEffect(() => {
        if (token) {
            const checkAuth = () => {
                try {
                    const jwtPayload = JSON.parse(atob(token.split('.')[1]));
                    const JWTtime = jwtPayload.exp * 1000;
                    if (Date.now() >= JWTtime) {
                        getNewToken();
                        // handleLogout();
                    } else if (JWTtime - Date.now() < 70000) {
                        getNewToken();
                    }
                } catch (error) {
                    console.error("Error parsing token:", error);
                    getNewToken();
                    // handleLogout();
                }
            };

            checkAuth();
            const timer = setInterval(checkAuth, 10000);

            return () => clearInterval(timer);
        }
    }, [token]);

    return <></>;
}

export default CheckLogin;
